import { gsap } from "gsap";

export default class GradientHeader {
    constructor(headerSelector, colorSets) {
        this.header = document.querySelector(headerSelector);
        this.colorSets = colorSets;
        this.screenWidth = window.innerWidth;

        // Sélection des stops du gradient dans le SVG
        this.stops = this.header.querySelectorAll('#headerGradient stop');

        this.bindEvents();
    }

    bindEvents() {
        window.addEventListener('mousemove', (e) => this.onMouseMove(e));
        window.addEventListener('resize', () => this.onResize());
    }

    onMouseMove(e) {
        const index = Math.floor(e.pageX / this.screenWidth * this.colorSets.length);
        const [color1, color2, color3] = this.colorSets[index];

        gsap.to(this.stops[0], { duration: 1.5, attr: { 'stop-color': color1 }, ease: "power2.out" });
        gsap.to(this.stops[1], { duration: 1.5, attr: { 'stop-color': color2 }, ease: "power2.out" });
        gsap.to(this.stops[2], { duration: 1.5, attr: { 'stop-color': color3 }, ease: "power2.out" });
    }

    onResize() {
        this.screenWidth = window.innerWidth;
    }
}